import { ShieldOff } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

/**
 * AccountDeactivated — shown by AuthGuard instead of the /sign-in redirect
 * when restoreSession's /api/auth/me call comes back 403 (deactivated
 * account). No "Sign in via Blast" button here on purpose: the Blast handoff
 * would just hand back the same token and loop straight back to this screen.
 */
export const AccountDeactivated = () => {
  const message = useAuthStore((s) => s.accountDeactivatedMessage);

  const handleTryAgain = () => {
    useAuthStore.setState({ accountDeactivated: false, accountDeactivatedMessage: null });
    void useAuthStore.getState().restoreSession();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="w-16 h-16 bg-red-100 dark:bg-red-950 rounded-2xl flex items-center justify-center mx-auto">
            <ShieldOff className="w-10 h-10 text-red-600 dark:text-red-400" />
          </div>
          <h1 className="mt-4 text-3xl font-bold text-gray-900 dark:text-gray-100">
            Account deactivated
          </h1>
          <p className="mt-3 text-base text-gray-600 dark:text-gray-300">
            {message || 'Your account has been deactivated. Contact an admin for access.'}
          </p>
        </div>

        <div className="card p-6 text-center">
          <button
            onClick={handleTryAgain}
            className="w-full px-4 py-3 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 rounded-lg font-medium hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  );
};
